// extracted by mini-css-extract-plugin
export default {"tabTitle":"tab-title_tabTitle__n+wps","removeLanguageBtn":"tab-title_removeLanguageBtn__uAOxw"};